import React from 'react';
import { features } from '../eiraa_mock';
import { Package, Sparkles, Zap, Award, Maximize, CheckCircle } from 'lucide-react';

const iconMap = {
  Package,
  Sparkles,
  Zap,
  Award,
  Maximize,
  CheckCircle
};

const EiraaFeatures = () => {
  return (
    <section id="features" className="py-24 bg-slate-900 text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-amber-400 font-semibold text-sm uppercase tracking-wider">Why Choose EIRAA</span>
          <h2 className="text-4xl md:text-5xl font-light mt-3 mb-4">
            Exceptional Quality, Accessible Luxury
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Experience the EIRAA difference with our commitment to quality, innovation, and customer satisfaction.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group bg-slate-800 p-8 rounded-2xl hover:bg-slate-700 transition-all duration-500 border border-slate-700 hover:border-amber-500"
                style={{
                  animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
                }}
              >
                <div className="w-14 h-14 bg-amber-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:bg-amber-500 transition-all duration-300">
                  <IconComponent className="text-white" size={28} />
                </div>
                <h3 className="text-xl font-bold mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-300 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default EiraaFeatures;